"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../../../state");
var _Component = require("./Component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Container = function Container(_ref) {
  var replenishPath = _ref.replenishPath,
    withdrawPath = _ref.withdrawPath,
    transactionsPath = _ref.transactionsPath;
  var history = (0, _reactRouterDom.useHistory)();
  var _useBalancesWithTotal = (0, _state.useBalancesWithTotal)(),
    balances = _useBalancesWithTotal.balances,
    balancesLoading = _useBalancesWithTotal.balancesLoading,
    totalBalanceState = _useBalancesWithTotal.totalBalanceState;
  var onDepositClick = function onDepositClick(ticker) {
    history.push(replenishPath, {
      ticker: ticker
    });
  };
  var onSendClick = function onSendClick(ticker) {
    history.push(withdrawPath, {
      ticker: ticker
    });
  };
  var onHistoryClick = function onHistoryClick(ticker) {
    history.push(transactionsPath, {
      ticker: ticker
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    loading: balancesLoading,
    onDepositClick: onDepositClick,
    onSendClick: onSendClick,
    onHistoryClick: onHistoryClick,
    totalBalance: totalBalanceState.data,
    balances: balances
  });
};
exports.Container = Container;